import React from 'react';
import cn from 'classnames';

import Button from 'shared/ui/Button/Button/Button';
import ArrowDownCard from 'shared/ui/icons/ArrowDownCard';
import {isTranslate} from 'shared/lib/lang';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import {t} from '@lingui/core/macro';

import styles from './TariffPrice.module.scss';

interface TariffPriceBlockProps {
    price: number;
    isActive: boolean;
    isArchive: boolean;
    onPayClick: () => void;
    onExpandClick: () => void;
    isExpanded: boolean;
}

const TariffPrice: React.FC<TariffPriceBlockProps> = ({
    price,
    isActive,
    isArchive,
    onPayClick,
    onExpandClick,
    isExpanded,
}) => {
    const isFree = price === 0;
    const isWarningButton = isFree || isArchive || isActive;

    const handlePayClick = () => {
        onPayClick();

        if (isActive || isArchive) {
            reachGoal(YM_GOALS.CLICK_EXTEND_TARIFF);

            return;
        }

        reachGoal(YM_GOALS.CLICK_TARIFF_PAY);
    };

    const getButtonLabel = () => {
        if (isFree) {
            return t`Бесплатно`;
        }

        if (isArchive) {
            return t`Продлить`;
        }

        return isActive ? t`Продлить тариф` : t`Оформить тариф`;
    };

    return (
        <div>
            <div className={styles.priceBlock}>
                {t`Стоимость`}
                <div className={styles.price}>
                    {price}
                    <span>
                        {!isTranslate() && ' руб.'}
                    </span>
                </div>
            </div>
            <div className={styles.blockButton}>
                <div className={styles.button_container}>
                    <Button
                        onClick={isFree ? undefined : handlePayClick}
                        disabled={isFree}
                        className={cn(
                            styles.button,
                            isWarningButton ? styles.button_warning : styles.button_default,
                        )}
                    >
                        {getButtonLabel()}
                    </Button>
                </div>
                <button
                    type="button"
                    className={cn(styles.arrow_icon, {[styles.expanded]: isExpanded})}
                    onClick={onExpandClick}
                    aria-expanded={isExpanded}
                    aria-label={isExpanded ? t`Скрыть подробности тарифа` : t`Показать подробности тарифа`}
                >
                    <ArrowDownCard />
                </button>
            </div>
        </div>
    );
};

export default TariffPrice;
